import type { DocumentSummary } from "~/api/types";
import type {
  DocumentEditableField,
  ArtifactEditableField,
  UpdateDocumentData,
} from "~/api/v2/requests";
import { isDraftArtifact } from "./documentPermissions";
import type { EditableField } from "./libraryTypes";

export const isArtifactEditableField = (
  field: EditableField,
): field is ArtifactEditableField =>
  field === "reviewFrom" || field === "reviewTo";

export const isEditableField = (
  document: DocumentSummary,
  field: EditableField | undefined,
): boolean => {
  if (field === undefined) return false;

  if (document.archivedAt !== null) {
    return false;
  }

  if (isArtifactEditableField(field)) {
    return isDraftArtifact(document.latestRelease);
  }

  return true;
};

const payloadKeysByEditableField: Record<
  DocumentEditableField,
  (keyof UpdateDocumentData)[]
> = {
  categoryId: ["categoryId"],
  tierId: ["tierId", "linkedDocumentIds"],
  referenceNumber: ["referenceNumber"],
  scheduleReviewPeriod: ["scheduleReviewPeriod"],
  ownerId: ["ownerId"],
  publisherId: ["publisherId"],
  tags: ["tagIds"],
  links: ["linkedDocumentIds"],
};

export const getPayloadForField = (
  field: DocumentEditableField,
  payload: UpdateDocumentData,
): UpdateDocumentData =>
  Object.fromEntries(
    Object.entries(payload).filter(([key]) =>
      payloadKeysByEditableField[field].includes(
        key as keyof UpdateDocumentData,
      ),
    ),
  );
